/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Large_Files_TipInputs */

const en_vault_large_files_tip = /** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For massive files or video courses, upload to a hidden external link (Drive, YouTube). Alternatively, upload a .zip file (max 50MB) natively.`)
};

const es_vault_large_files_tip = /** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para archivos enormes o cursos en video, súbelos a un enlace externo oculto (Drive, YouTube). Alternativamente, sube un archivo .zip (máx. 50MB) de forma nativa.`)
};

const fr_vault_large_files_tip = /** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les fichiers massifs ou les cours vidéo, téléchargez-les vers un lien externe masqué (Drive, YouTube). Alternativement, uploadez un fichier .zip (max 50 Mo) nativement.`)
};

const de_vault_large_files_tip = /** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für riesige Dateien oder Videokurse lade diese auf einen versteckten externen Link hoch (Drive, YouTube). Alternativ kannst du eine .zip-Datei (max. 50MB) nativ hochladen.`)
};

const id_vault_large_files_tip = /** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk file sangat besar atau kursus video, unggah ke tautan eksternal tersembunyi (Drive, YouTube). Sebagai alternatif, unggah file .zip (maks 50MB) secara bawaan.`)
};

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const ja_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const zh_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const ar_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const it_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const ru_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const pt_vault_large_files_tip = en_vault_large_files_tip;

/** @type {(inputs: Vault_Large_Files_TipInputs) => LocalizedString} */
const ko_vault_large_files_tip = en_vault_large_files_tip;

/**
* | output |
* | --- |
* | "For massive files or video courses, upload to a hidden external link (Drive, YouTube). Alternatively, upload a .zip file (max 50MB) natively." |
*
* @param {Vault_Large_Files_TipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_large_files_tip = /** @type {((inputs?: Vault_Large_Files_TipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Large_Files_TipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_large_files_tip(inputs)
	if (locale === "es") return es_vault_large_files_tip(inputs)
	if (locale === "fr") return fr_vault_large_files_tip(inputs)
	if (locale === "de") return de_vault_large_files_tip(inputs)
	if (locale === "ja") return ja_vault_large_files_tip(inputs)
	if (locale === "zh") return zh_vault_large_files_tip(inputs)
	if (locale === "ar") return ar_vault_large_files_tip(inputs)
	if (locale === "id") return id_vault_large_files_tip(inputs)
	if (locale === "it") return it_vault_large_files_tip(inputs)
	if (locale === "ru") return ru_vault_large_files_tip(inputs)
	if (locale === "pt") return pt_vault_large_files_tip(inputs)
	return ko_vault_large_files_tip(inputs)
});